import { createSlice } from '@reduxjs/toolkit';
import { getBrowserWarningMessage } from '../utils/browserUtils';

const initialState = {
    browserInfo: null,
    showWarning: false,
    warningMessage: null,
    isDismissed: false
};

const browserSlice = createSlice({
    name: 'browser',
    initialState,
    reducers: {
        setBrowserInfo: (state, action) => {
            state.browserInfo = action.payload;
            const warning = getBrowserWarningMessage(action.payload);
            state.warningMessage = warning;
            state.showWarning = warning !== null && !state.isDismissed;
        },
        dismissWarning: (state) => {
            state.isDismissed = true;
            state.showWarning = false;
        },
        resetBrowserState: (state) => {
            Object.assign(state, initialState);
        }
    },
});

export const { setBrowserInfo, dismissWarning, resetBrowserState } = browserSlice.actions;

export default browserSlice.reducer;
